import { Global as EmotionGlobal } from "@emotion/react";

const Fonts = () => (
  <EmotionGlobal
    styles={`
      @font-face {
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(/docs/fonts/Inter-Regular.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: italic;
        font-weight: 400;
        font-display: swap;
        src: url(/docs/fonts/Inter-Italic.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(/docs/fonts/Inter-Medium.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: italic;
        font-weight: 500;
        font-display: swap;
        src: url(/docs/fonts/Inter-MediumItalic.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(/docs/fonts/Inter-SemiBold.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: italic;
        font-weight: 600;
        font-display: swap;
        src: url(/docs/fonts/Inter-SemiBoldItalic.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(/docs/fonts/Inter-Bold.woff2) format("woff2");
      }
      @font-face {
        font-family: "Inter";
        font-style: italic;
        font-weight: 700;
        font-display: swap;
        src: url(/docs/fonts/Inter-BoldItalic.woff2) format("woff2");
      }
      @font-face {
        font-family: "Nuckle";
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(/docs/fonts/Nuckle-Regular.woff2) format("woff2");
      }
      @font-face {
        font-family: "Nuckle";
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(/docs/fonts/Nuckle-SemiBold.woff2) format("woff2");
      }
      @font-face {
        font-family: "Nuckle";
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(/docs/fonts/Nuckle-Bold.woff2) format("woff2");
      }
      @font-face {
        font-family: "DM Mono";
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(/docs/fonts/DMMono-Regular.woff2) format("woff2");
      }
      @font-face {
        font-family: "DM Mono";
        font-style: italic;
        font-weight: 400;
        font-display: swap;
        src: url(/docs/fonts/DMMono-Italic.woff2) format("woff2");
      }
      @font-face {
        font-family: "DM Mono";
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(/docs/fonts/DMMono-Medium.woff2) format("woff2");
      }
      /* Metric-matched fallbacks (capsize, from the woff2 metrics) so the
         swap barely moves text. Regenerate if the font files change. */
      @font-face {
        font-family: "Inter Fallback";
        src: local("Arial"), local("ArialMT");
        ascent-override: 90.4365%;
        descent-override: 22.518%;
        line-gap-override: 0%;
        size-adjust: 107.1194%;
      }
      @font-face {
        font-family: "Nuckle Fallback";
        src: local("Arial"), local("ArialMT");
        ascent-override: 86.2547%;
        descent-override: 22.6986%;
        line-gap-override: 0%;
        size-adjust: 110.1389%;
      }
      @font-face {
        font-family: "DM Mono Fallback";
        src: local("Courier New"), local("CourierNewPSMT");
        ascent-override: 99.2161%;
        descent-override: 31.005%;
        size-adjust: 99.9837%;
      }
    `}
  />
);

const Code = () => (
  <EmotionGlobal
    styles={`
    .hljs-comment {
      color: var(--theme-colors-text-secondary)
    }
    .hljs-addition {
      color: var(--theme-colors-success-700);
      background: var(--theme-colors-success-100);
    }
    .hljs-deletion {
      color: var(--theme-colors-danger-700);
      background: var(--theme-colors-danger-100);
    }
  `}
  />
);

const PylonOverrides = () => (
  <EmotionGlobal
    styles={`
      button.chakra-button {
        border-radius: var(--theme-radii-lg) !important;
      }
    `}
  />
);

export const Global = () => (
  <>
    <Code />
    <Fonts />
    <PylonOverrides />
  </>
);
